import React, { useEffect, useState } from "react"
import FacebookLogin from "react-facebook-login"
import { useSelector, useDispatch } from "react-redux"
import DeleteConfirmationModal from "newcomponents/delete-modal"
import {
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Col,
  Row,
  Badge,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Label,
  Input,
  Spinner,
  FormGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import {
  updateOrganizationRequest,
  resetOrgFlag,
} from "../../store/Organization/actions"
import axios from "axios"
import { setBreadcrumbItems } from "../../store/actions"
import FacebookIcon from "../../assets/images/icons/facebook.png"
import InstagramIcon from "../../assets/images/icons/instagram.png"
import LinkedinIcon from "../../assets/images/icons/linkedin.png"
import YelpIcon from "../../assets/images/icons/yelp.svg"
import WebMDIcon from "../../assets/images/icons/webmd.png"
import ReviewsIcon from "../../assets/images/icons/reviews.png"
import HealthGradeIcon from "../../assets/images/icons/healthgrade.png"
import AnalyticsIcon from "../../assets/images/icons/analytics.png"
import VitalsIcon from "../../assets/images/icons/vitals.png"
import AthenaIcon from "../../assets/images/icons/athena.png"
import SnackbarComponent from "components/SnackBar"
import "./index.css"
import { useLocation, useParams } from "react-router-dom"

import config from "config/config"
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js"
import { Line } from "react-chartjs-2"
import { validateVitalsPracticeBaseUrl } from "helpers/validate-vitals-url"
import { validateHealthgradesGroupUrl } from "helpers/validate-healthgrade-url"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import PrimaryButton from "newcomponents/primary-button"
import FetchModal from "newcomponents/fetch-modal"
// Register the components
ChartJS.register(BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend)

const IntegrationsPage = props => {
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false)
  const [integrationToDisconnect, setIntegrationToDisconnect] = useState(null)
  const location = useLocation()
  const mode = useSelector(state => state.Layout.layoutMode)
  const userData = useSelector(state => state.Login.userData)
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const [filterDropdownOpen, setFilterDropdownOpen] = useState(false)
  const [selectedFilters, setSelectedFilters] = useState({}) // Tracks selected filters

  const toggleFilterDropdown = () => setFilterDropdownOpen(!filterDropdownOpen)
  const [err, setErr] = useState(null)
  const [success, setSuccess] = useState(null)
  const [loading, setLoading] = useState(false)
  const [integrations, setIntegrations] = useState([])
  const [fbPages, setFbPages] = useState([])
  const [instaPages, setInstaPages] = useState([])
  const [selectedFbPage, setSelectedFbPage] = useState(null)
  const [selectedInstaPage, setSelectedInstaPage] = useState(null)
  const [healthgridFetchedData, setHealthgridFetchedData] = useState(null)
  const [yelpFetchedData, setYelpFetchedData] = useState(null)
  const [vitalsFetchedData, setVitalsFetchedData] = useState(null)
  const [healthgradeUrl, setHealthgradeUrl] = useState(null)
  const [yelpUrl, setYelpUrl] = useState(null)
  const [athenaId, setAthenaId] = useState(null)
  const [vitalsUrl, setVitalsUrl] = useState(null)
  const [facebookPageSelectionModelOpen, setFacebookPageSelectionModalOpen] =
    useState(false)
  const [instagramPageSelectionModelOpen, setInstagramPageSelectionModalOpen] =
    useState(false)
  const [healthgradeConfirmationModelOpen, setHealthgridConfirmationModalOpen] =
    useState(false)
  const [yelpConfirmationModelOpen, setYelpConfirmationModalOpen] =
    useState(false)
  const [vitalsConfirmationModelOpen, setVitalsConfirmationModalOpen] =
    useState(false)
  const [athenaConfirmationModelOpen, setAthenaConfirmationModalOpen] =
    useState(false)
  const toggleFacebookPageSelectionModal = () =>
    setFacebookPageSelectionModalOpen(!facebookPageSelectionModelOpen)
  const toggleInstagramPageSelectionModal = () =>
    setInstagramPageSelectionModalOpen(!instagramPageSelectionModelOpen)
  const toggleHealthgradeConfirmationModal = () =>
    setHealthgridConfirmationModalOpen(!healthgradeConfirmationModelOpen)
  const toggleYelpConfirmationModal = () =>
    setYelpConfirmationModalOpen(!yelpConfirmationModelOpen)
  const toggleVitalsConfirmationModal = () =>
    setVitalsConfirmationModalOpen(!vitalsConfirmationModelOpen)
  const toggleAthenaConfirmationModal = () =>
    setAthenaConfirmationModalOpen(!athenaConfirmationModelOpen)
  const dispatch = useDispatch()
  const [userInfo, setUserInfo] = useState({
    name: "",
    email: "",
    id: 0,
    accessToken: "",
    tokenExpiry: "",
    refreshToken: "",
    platform: "",
  })

  const breadcrumbItems = [
    {
      title: `${activeOrganization.name} (${activeOrganization.type})`,
      link: "/",
    },
    { title: "Integrations", link: "#" },
  ]

  useEffect(() => {
    console.log("Location Search:", location.search) // Ensure query parameters are available
    const params = new URLSearchParams(location.search)

    const name = params.get("name")
    const email = params.get("email")
    const id = params.get("id")
    const accessToken = params.get("accessToken")
    const refreshToken = params.get("refreshToken")
    const tokenExpiry = params.get("tokenExpiry")
    const platform = params.get("platform")

    console.log("Parsed Params:", {
      name,
      email,
      id,
      accessToken,
      refreshToken,
      tokenExpiry,
      platform,
    })

    if (platform) {
      setUserInfo({
        accessToken,
        tokenExpiry,
        refreshToken,
        platform,
      })
    } else {
      if (name && email && tokenExpiry) {
        setUserInfo({
          name,
          email,
          id: Number(id) || 0, // Ensure id is a number
          accessToken,
          tokenExpiry,
          refreshToken,
          platform,
        })
        setAnalyticsModalOpen(true)
      }
    }

    dispatch(setBreadcrumbItems(`Integrations`, breadcrumbItems))
  }, [location.search])

  useEffect(() => {
    setIntegrations([
      {
        name: "Facebook",
        status: activeOrganization.FacebookIntegrations[0]
          ? "Connected"
          : "Not Connected",
        Icon: FacebookIcon,
      },
      {
        name: "Instagram",
        status: activeOrganization.InstagramIntegrations[0]
          ? "Connected"
          : "Not Connected",
        Icon: InstagramIcon,
      },
      // { name: "LinkedIn", status: "Not Connected", Icon: LinkedinIcon },
      {
        name: "Yelp",
        status: activeOrganization.YelpIntegrations[0]
          ? "Connected"
          : "Not Connected",
        Icon: YelpIcon,
      },
      {
        name: "Vitals.com",
        status: activeOrganization.VitalsIntegrations[0]
          ? "Connected"
          : "Not Connected",
        Icon: VitalsIcon,
      },
      // { name: "WebMD", status: "Not Connected", Icon: WebMDIcon },
      {
        name: "HealthGrade",
        status: activeOrganization.HealthgradeIntegrations[0]
          ? "Connected"
          : "Not Connected",
        Icon: HealthGradeIcon,
      },
      // { name: "Google Reviews", status: "Not Connected", Icon: ReviewsIcon },
      {
        name: "Google Analytics",
        status: activeOrganization.GoogleAnalyticsIntegrations[0]
          ? "Connected"
          : "Not Connected",
        Icon: AnalyticsIcon,
      },
      {
        name: "Athena Health",
        status: activeOrganization.athenaLocationId
          ? "Connected"
          : "Not Connected",
        Icon: AthenaIcon,
      },
    ])

    console.log("active Organization", activeOrganization)

    if (
      activeOrganization.GoogleAnalyticsIntegrations[0] &&
      userInfo.accessToken
    ) {
      window.location.href = "/integrations"
    }
  }, [activeOrganization])

  const getStatusBadge = status => {
    return status === "Connected" ? (
      <Badge
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "12px",
        }}
        color="success"
      >
        <i style={{ fontSize: "18px" }} className="mdi mdi-link-variant"></i>
        Connected
      </Badge>
    ) : (
      <Badge
        color="danger"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "12px",
        }}
      >
        <i
          className="mdi mdi-link-variant-off"
          style={{ fontSize: "18px" }}
        ></i>
        Not Connected
      </Badge>
    )
  }

  const responseFacebook = async response => {
    const accessToken = response.accessToken
    const userId = response.id
    try {
      const response = await axios.post(
        `${config.backendUrl}/facebook/getPages`,
        { accessToken, organizationId: activeOrganization.id, userId },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      setFbPages(response.data.accounts.data)
      if (response.data.accounts.data.length > 0) {
        toggleFacebookPageSelectionModal()
      } else {
        setErr("No pages found.")
      }
    } catch (err) {
      setErr("Error fetching user pages.")
    }
  }
  const responseInstagram = async response => {
    const accessToken = response.accessToken
    const userId = response.id
    console.log("first", response)
    try {
      const response = await axios.post(
        `${config.backendUrl}/instagram/getPages`,
        { accessToken, organizationId: activeOrganization.id, userId },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      if (
        response.status === 400 &&
        response.data.message === "Instagram account not found"
      ) {
        setErr("Your Instagram account is not connected to meta.")

        return
      }

      setInstaPages(response.data.accounts.data)
      if (response.data.accounts.data.length > 0) {
        toggleInstagramPageSelectionModal()
      } else {
        setErr("No pages found.")
      }
    } catch (err) {
      setErr("Error fetching user pages.")
    }
  }

  // Function to handle page selection
  const handlePageSelect = page => {
    setSelectedFbPage(page)
  }
  const handleInstaPageSelect = page => {
    setSelectedInstaPage(page)
  }
  const handlePageSubmit = async () => {
    try {
      const response = await axios.post(
        `${config.backendUrl}/facebook/getPageData`,
        {
          accessToken: selectedFbPage.access_token,
          pageId: selectedFbPage.id,
          organizationId: activeOrganization.id,
        },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      setSuccess(`Facebook Page "${selectedFbPage.name}" connected.`)
      dispatch(
        updateOrganizationRequest({
          organizationId: activeOrganization.id,
          ...activeOrganization,
        }),
      )

      toggleFacebookPageSelectionModal()
    } catch (err) {
      setErr("Error Selecting Page")
    }
  }
  const handleInstaPageSubmit = async () => {
    try {
      const response = await axios.post(
        `${config.backendUrl}/instagram/getPageData`,
        {
          accessToken: selectedInstaPage.access_token,
          pageId: selectedInstaPage.id,
          organizationId: activeOrganization.id,
        },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      setSuccess(`Instagram Page "${selectedInstaPage.name}" connected.`)
      dispatch(
        updateOrganizationRequest({
          organizationId: activeOrganization.id,
          ...activeOrganization,
        }),
      )

      toggleInstagramPageSelectionModal()
    } catch (err) {
      console.log(err)
      setErr("Error Selecting Page")
    }
  }

  const toggleConfirmationModal = () =>
    setConfirmationModalOpen(!confirmationModalOpen)

  const handleDisconnectRequest = int => {
    setIntegrationToDisconnect(int)
    toggleConfirmationModal()
  }

  const handleConfirmDisconnect = async () => {
    if (!integrationToDisconnect) return

    toggleConfirmationModal() // Close confirmation modal
    setLoading(true)

    try {
      if (integrationToDisconnect === "Facebook") {
        // Disconnect Facebook logic
        await axios.post(
          `${config.backendUrl}/facebook/disconnect`,
          { organizationId: activeOrganization.id },
          {
            headers: {
              Authorization: `Bearer ${userData.token}`,
            },
          },
        )
        setSuccess("Facebook disconnected successfully.")
        dispatch(
          updateOrganizationRequest({
            organizationId: activeOrganization.id,
            ...activeOrganization,
          }),
        )
      } else if (integrationToDisconnect === "HealthGrade") {
        // Disconnect HealthGrade logic
        await axios.delete(
          `${config.backendUrl}/healthgrade/disconnectHealthgrade?orgId=${activeOrganization.id}`,
          {
            headers: {
              Authorization: `Bearer ${userData.token}`,
            },
          },
        )
        setSuccess("HealthGrade disconnected successfully.")
        dispatch(
          updateOrganizationRequest({
            organizationId: activeOrganization.id,
            ...activeOrganization,
          }),
        )
      } else if (integrationToDisconnect === "Yelp") {
        // Disconnect Yelp logic
        await axios.delete(
          `${config.backendUrl}/yelp/disconnectYelp?orgId=${activeOrganization.id}`,
          {
            headers: {
              Authorization: `Bearer ${userData.token}`,
            },
          },
        )
        setSuccess("Yelp disconnected successfully.")
        dispatch(
          updateOrganizationRequest({
            organizationId: activeOrganization.id,
            ...activeOrganization,
          }),
        )
      } else if (integrationToDisconnect === "Google Analytics") {
        // Disconnect Google Analytics logic
        await axios.delete(
          `${config.backendUrl}/analytics/disconnect?orgId=${activeOrganization.id}`,
          {
            headers: {
              Authorization: `Bearer ${userData.token}`,
            },
          },
        )
        setSuccess("Google Analytics disconnected successfully.")
        dispatch(
          updateOrganizationRequest({
            organizationId: activeOrganization.id,
            ...activeOrganization,
          }),
        )
      } else if (integrationToDisconnect === "Instagram") {
        // Disconnect Facebook logic
        await axios.post(
          `${config.backendUrl}/instagram/disconnect`,
          { organizationId: activeOrganization.id },
          {
            headers: {
              Authorization: `Bearer ${userData.token}`,
            },
          },
        )
        setSuccess("Instagram disconnected successfully.")
        dispatch(
          updateOrganizationRequest({
            organizationId: activeOrganization.id,
            ...activeOrganization,
          }),
        )
      } else if (integrationToDisconnect === "Vitals.com") {
        console.log("Hello")
        await axios.post(
          `${config.backendUrl}/vitals/disconnect?orgId=${activeOrganization.id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${userData.token}`,
            },
          },
        )
        setSuccess("Vitals disconnected successfully.")
        dispatch(
          updateOrganizationRequest({
            organizationId: activeOrganization.id,
            ...activeOrganization,
          }),
        )
      } else if (integrationToDisconnect === "Athena Health") {
        console.log("Hello")
        await axios.post(
          `${config.backendUrl}/athena/disconnect?orgId=${activeOrganization.id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${userData.token}`,
            },
          },
        )
        setSuccess("Athena disconnected successfully.")
        dispatch(
          updateOrganizationRequest({
            organizationId: activeOrganization.id,
            ...activeOrganization,
          }),
        )
      }
    } catch (err) {
      console.error(`Error disconnecting ${integrationToDisconnect}:`, err)
      setErr(`Error disconnecting ${integrationToDisconnect}.`)
    } finally {
      setLoading(false)
      setIntegrationToDisconnect(null) // Reset the integration
    }
  }

  const connectIntegration = name => {
    console.log("name", name)
    if (name === "HealthGrade") {
      toggleHealthgradeConfirmationModal()
    }
    if (name === "Yelp") {
      toggleYelpConfirmationModal()
    }
    if (name === "Google Analytics") {
      handleGoogleLogin()
    }
    if (name === "Vitals.com") {
      toggleVitalsConfirmationModal()
    }

    if (name === "Athena Health") {
      toggleAthenaConfirmationModal()
    }

    if (name === "Google Reviews") {
      console.log("Reviews")
      window.location.href = `${config.backendUrl}/reviews/authUrl?orgId=${activeOrganization.id}`
    }
  }

  const handleHealthgradeUrlChange = e => {
    const url = e.target.value
    setHealthgradeUrl(url)
  }
  const handleYelpUrlChange = e => {
    const url = e.target.value

    // Regex pattern to match a Yelp business URL
    const yelpUrlPattern = /^https:\/\/www\.yelp\.com\/biz\/[a-zA-Z0-9\-]+$/

    setYelpUrl(url)

    if (!yelpUrlPattern.test(url)) {
      setErr("Please enter a valid Yelp URL.")
    } else {
      setErr("") // Clear the error message when the URL is valid
    }
  }
  const handleVitalsUrlChange = e => {
    const url = e.target.value
    setVitalsUrl(url)
  }

  const fetchData = async () => {
    if (healthgradeConfirmationModelOpen) {
      const res = validateHealthgradesGroupUrl(healthgradeUrl)
      if (res.ok) {
        try {
          setLoading(true)
          const response = await axios.get(
            `${config.backendUrl}/healthgrade/getDetails?url=${healthgradeUrl}`,
            {
              headers: {
                Authorization: `Bearer ${userData.token}`,
              },
            },
          )
          setHealthgridFetchedData(response.data)
          setLoading(false)
        } catch (err) {
          console.log(err)
          setLoading(false)
          setErr("Error fetching data, please try fixing url.")
        }
      } else {
        setErr(res.err)
      }
      setErr(res.ok ? "" : res.error)
    }

    if (yelpConfirmationModelOpen) {
      try {
        setLoading(true)
        const response = await axios.get(
          `${config.backendUrl}/yelp/getDetails?url=${yelpUrl}`,
          {
            headers: {
              Authorization: `Bearer ${userData.token}`,
            },
          },
        )
        setYelpFetchedData(response.data)
        setLoading(false)
      } catch (err) {
        console.log(err)
        setLoading(false)
        setErr("Error fetching data, please try fixing url.")
      }
    }
    if (vitalsConfirmationModelOpen) {
      try {
        setLoading(true)

        const res = validateVitalsPracticeBaseUrl(vitalsUrl)

        if (res.ok) {
          const response = await axios.get(
            `${config.backendUrl}/vitals/getDetails?url=${vitalsUrl}`,
            {
              headers: {
                Authorization: `Bearer ${userData.token}`,
              },
            },
          )
          setVitalsFetchedData(response.data)
          setLoading(false)
        } else {
          setErr(res.error)
          setLoading(false)
        }
      } catch (err) {
        console.log(err)
        setErr("Error fetching data, please try fixing url.")
      }
    }
  }
  const confirmHealthgrade = async () => {
    try {
      setLoading(true)
      const response = await axios.get(
        `${config.backendUrl}/healthgrade/connectHealthgrade?url=${healthgradeUrl}&orgId=${activeOrganization.id}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )
      setSuccess("Healthgrade connected successfully")
      dispatch(
        updateOrganizationRequest({
          organizationId: activeOrganization.id,
          ...activeOrganization,
        }),
      )
      setHealthgradeUrl("")
      setHealthgridFetchedData(null)
      toggleHealthgradeConfirmationModal()
      setLoading(false)
    } catch (err) {
      console.log(err)
      setLoading(false)
      setErr("Error fetching data, please try fixing url.")
    }
  }

  const onConfirmAthena = async () => {
    if (!athenaId?.trim()) {
      setErr("Please enter a Practice ID.")
      return
    }

    try {
      setLoading(true)
      setErr("")
      setSuccess("")

      const { data } = await axios.get(
        `${config.backendUrl}/athena/validate-practice`,
        {
          params: { practiceId: athenaId.trim(), orgId: activeOrganization.id }, // e.g., "195900"
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      if (data?.ok) {
        // success UI message
        const ref = data?.practice?.reference || ""
        setSuccess(`Practice verified${ref ? `: ${ref}` : ""}.`)
        // close modal (if that’s your UX)
        toggleAthenaConfirmationModal()

        dispatch(
          updateOrganizationRequest({
            organizationId: activeOrganization.id,
            ...activeOrganization,
          }),
        )
        // optionally kick off a "save to DB" call here if not already done server-side
        return
      }

      // API returned ok: false
      setErr(data?.error || "Practice validation failed.")
    } catch (e) {
      // Try to surface Athena OperationOutcome text if present
      const outcomeText =
        e?.response?.data?.details?.issue?.[0]?.details?.text ||
        e?.response?.data?.error ||
        e?.response?.data?.message ||
        e?.message ||
        "Unknown error"

      setErr(`Practice validation failed: ${outcomeText}`)
    } finally {
      setLoading(false)
    }
  }

  const confirmYelp = async () => {
    try {
      setLoading(true)
      const response = await axios.get(
        `${config.backendUrl}/yelp/connectYelp?url=${yelpUrl}&orgId=${activeOrganization.id}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )
      setSuccess("Yelp connected successfully")

      setYelpUrl("")
      setYelpFetchedData(null)
      toggleYelpConfirmationModal()
      setLoading(false)
    } catch (err) {
      console.log(err)
      setLoading(false)
      setErr("Error fetching data, please try fixing url or try again later.")
    }
  }
  const confirmVitals = async () => {
    try {
      setLoading(true)
      console.log(activeOrganization, "Active Org")
      const response = await axios.get(
        `${config.backendUrl}/vitals/connectVitals?url=${vitalsUrl}&orgId=${activeOrganization.id}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )
      setSuccess("Vital connected successfully")
      dispatch(
        updateOrganizationRequest({
          organizationId: activeOrganization.id,
          ...activeOrganization,
        }),
      )
      setYelpUrl("")
      setYelpFetchedData(null)
      toggleVitalsConfirmationModal()
      setLoading(false)
    } catch (err) {
      console.log(err)
      setLoading(false)
      setErr("Error fetching data, please try fixing url or try again later.")
    }
  }
  const handleGoogleLogin = () => {
    // Redirect the user to the backend API to start OAuth2 login
    window.location.href = `${config.backendUrl}/analytics/authURL?orgId=${activeOrganization.id}`
  }
  const [viewIds, setViewIds] = useState([])
  const [properties, setProperties] = useState([])
  const [viewAccounts, setViewAccounts] = useState([])
  const [selectedAccount, setSelectedAccount] = useState(null)
  const [viewProperties, setViewProperties] = useState([])
  const [selectedProperty, setSelectedProperty] = useState(null)
  const [analyticsAccountId, setAnalyticsAccountId] = useState(null)

  const [analyticsModalOpen, setAnalyticsModalOpen] = useState(false)

  const toggleAnalyticsModal = () => setAnalyticsModalOpen(!analyticsModalOpen)

  // Parse query parameters and open modal automatically if redirected

  // Fetch Google Analytics accounts
  const fetchAccounts = async () => {
    try {
      const response = await axios.get(
        `${config.backendUrl}/analytics/getAccounts?accessToken=${userInfo.accessToken}`,
      )
      setViewAccounts(response.data)
    } catch (error) {
      console.error("Error fetching accounts", error)
    }
  }

  // Fetch properties for the selected account
  const fetchProperties = async accountId => {
    try {
      const response = await axios.get(
        `${config.backendUrl}/analytics/getProperties?accessToken=${userInfo.accessToken}&accountId=${accountId}`,
      )
      setViewProperties(response.data)
    } catch (error) {
      console.error("Error fetching properties", error)
    }
  }

  // Confirm the selected account and property
  const confirmGoogleAnalyticsConnection = async () => {
    try {
      console.log("Acoutn Id", selectedAccount)
      console.log("Acoutdsssn Id", selectedProperty)
      console.log("User Info: ", userInfo)

      console.log("Active Org", activeOrganization)

      await axios.post(
        `${config.backendUrl}/analytics/saveSelection`,
        {
          accountId: selectedAccount?.name.split("/")[1],
          propertyId: selectedProperty?.name.split("/")[1],
          organizationId: activeOrganization.id,
          ...userInfo,
        },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      toggleAnalyticsModal()
      setSuccess("Google Analytics Connected Successfully.")
      dispatch(
        updateOrganizationRequest({
          organizationId: activeOrganization.id,
          ...activeOrganization,
        }),
      )
    } catch (error) {
      console.error("Error saving selection", error)
    }
  }

  const fetchGoogleLocations = async () => {
    try {
      const response = await axios.get(
        `${config.backendUrl}/reviews/fetchLocations?accessToken=${userInfo.accessToken}&orgId=${activeOrganization.id}&refreshToken=${userInfo.refreshToken}&tokenExpiry=${userInfo.tokenExpiry}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      console.log("Reviews fetched:", response)
      setSuccess("Google Reviews Fetched Successfully.")
      dispatch(
        updateOrganizationRequest({
          organizationId: activeOrganization.id,
          ...activeOrganization,
        }),
      )
    } catch (error) {
      console.error("Error fetching reviews", error)
      setErr("Error fetching reviews")
    }
  }

  useEffect(() => {
    if (userInfo.platform === "googleReviews") {
      fetchGoogleLocations()
    } else {
      if (analyticsModalOpen && userInfo.accessToken) {
        fetchAccounts() // Fetch accounts when modal opens
      }
    }
  }, [analyticsModalOpen, userInfo])

  useEffect(() => {
    // Initialize selectedFilters with all integrations checked by default
    const initialFilters = integrations.reduce((acc, integration) => {
      acc[integration.name] = true
      return acc
    }, {})
    setSelectedFilters(initialFilters)
  }, [integrations])

  const handleFilterChange = platform => {
    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      [platform]: !prevFilters[platform],
    }))
  }

  const filteredIntegrations = integrations.filter(
    int => selectedFilters[int.name],
  )

  return (
    <div className="integrations-page">
      <SnackbarComponent
        err={err}
        success={success}
        setErr={setErr}
        setSuccess={setSuccess}
      />
      <div
        style={{
          backgroundColor: mode === "dark" ? "#252f40" : "#fff",
          marginTop: "0px",
          padding: "15px 20px",
          fontFamily: "Inter",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          color: mode === "dark" ? "#fff" : "#050409",
          fontWeight: "600",
          fontSize: "23px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        {/* Left side: org name */}
        <h1
          style={{
            fontWeight: "500",
            marginTop: "10px",
          }}
        >
          Admin Consoles
        </h1>
        {/* <PrimaryButton
          style={{
            padding: "15px 30px",
            fontSize: "20px",
            fontWeight: "500",
            borderRadius: "8px",
            backgroundColor: mode === "dark" ? "#252f40" : "#fff",
            border: mode === "dark" ? "1px solid #fff" : "1px solid #2990DF",
            color: mode === "dark" ? "#fff" : "#2990DF",
            textTransform: "none",
          }}
          icon={<ArrowForwardIcon />}
          onClick={() => {
            window.location.href = `/create-campaign`
          }}
        >
          Request New Integration
        </PrimaryButton> */}
      </div>
      <div
        style={{
          backgroundColor: mode === "dark" ? "#252f40" : "#fff",
          borderRadius: "20px",
          padding: "20px",
          boxShadow:
            mode === "dark"
              ? "0 4px 8px rgba(0, 0, 0, 0.2)"
              : "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Header + Filter Row */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4
            style={{
              fontWeight: "500",
              color: mode === "dark" ? "white" : "black",
              fontFamily: "inter",
              fontSize: "16px",
              margin: 0, // removes default bottom margin so it's aligned properly
            }}
          >
            Integrations
          </h4>

          <Dropdown isOpen={filterDropdownOpen} toggle={toggleFilterDropdown}>
            <DropdownToggle caret>Filter Platforms</DropdownToggle>
            <DropdownMenu>
              {integrations.map((int, index) => (
                <DropdownItem key={index} toggle={false}>
                  <div className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      checked={selectedFilters[int.name] || false}
                      onChange={() => handleFilterChange(int.name)}
                      className="me-2"
                    />
                    {int.name}
                  </div>
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </div>
        <Row>
          {filteredIntegrations?.map((int, index) => (
            <Col xl={4} md={4} sm={12} key={index} className="mb-4">
              <Card
                className="shadow-sm border-0 h-100 hover-card"
                style={{
                  borderRadius: "20px",
                  backgroundColor: mode === "dark" ? "#1F2431" : "#F5F5F5",
                  boxShadow:
                    mode === "dark"
                      ? "0 4px 8px rgba(0, 0, 0, 0.2)"
                      : "0 4px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                <CardBody
                  style={{
                    backgroundColor: mode === "dark" ? "#1F2431" : "#F5F5F5",
                    borderTopRightRadius: "20px",
                    borderTopLeftRadius: "20px",
                  }}
                  className="d-flex align-items-center justify-content-start"
                >
                  <div className="integration-icon me-3">
                    <img
                      src={int.Icon}
                      alt={`${int.name} icon`}
                      style={{ width: "50px", height: "50px" }}
                    />
                  </div>
                  <div className="integration-info">
                    <CardTitle
                      tag="h5"
                      style={{
                        fontWeight: "600",
                        fontSize: "24px",
                        fontFamily: "inter",
                        color: mode === "dark" ? "white" : "black",
                      }}
                      className="mb-2"
                    >
                      {int.name}
                    </CardTitle>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: "5px",
                      }}
                    >
                      {/* {int.status === "Connected" ? (
                      <i
                        style={{ fontSize: "18px" }}
                        color="success"
                        className="mdi mdi-link-variant"
                      ></i>
                    ) : (
                      <i className="mdi mdi-link-variant-off"></i>
                    )} */}
                      <div>
                        {int.status !== "Connected" && (
                          <span
                            style={{
                              fontSize: "12px",
                            }}
                          >
                            {`Connect your account with Aeravue`}
                          </span>
                        )}
                      </div>
                      {/* <div>
                        {int.name === "Facebook" &&
                        activeOrganization.FacebookIntegrations[0]
                          ? getStatusBadge("Connected")
                          : getStatusBadge(int.status)}
                      </div> */}
                    </div>
                  </div>
                </CardBody>
                <CardFooter
                  style={{
                    backgroundColor: mode === "dark" ? "#1F2431" : "#F5F5F5",
                    borderBottomLeftRadius: "20px",
                    borderBottomRightRadius: "20px",
                  }}
                >
                  {int.name === "Facebook" &&
                  activeOrganization.FacebookIntegrations[0] ? (
                    <PrimaryButton
                      style={{
                        textTransform: "capitalize",
                        width: "114px",
                        height: "40px",
                        backgroundColor: "#E0E3E8",
                        color: "#000",
                      }}
                      size="sm"
                      color="danger"
                      onClick={() => handleDisconnectRequest(int.name)}
                    >
                      Disconnect
                    </PrimaryButton>
                  ) : int.name === "Facebook" ? (
                    <FacebookLogin
                      appId="517315014350498"
                      autoLoad={false}
                      fields="name,email,picture"
                      scope="public_profile,email,pages_show_list,read_insights,pages_manage_posts,pages_messaging,pages_manage_metadata,pages_read_engagement,pages_read_user_content,instagram_basic,instagram_content_publish,business_management"
                      callback={responseFacebook}
                      version="20.0"
                      buttonStyle={{
                        padding: "5px 10px",
                        fontSize: "16px",
                        width: "114px",
                        height: "40px",
                        borderRadius: "5px",
                        backgroundColor: "#2990DF",
                        textTransform: "capitalize",
                        fontFamily: "inter",
                        fontWeight: "400",
                        borderOutline: "none",
                        border: "none",
                      }}
                      textButton="Connect"
                    />
                  ) : int.name === "Instagram" &&
                    !activeOrganization.InstagramIntegrations[0] ? (
                    <FacebookLogin
                      appId="517315014350498" // Use the same or a different app ID depending on your setup
                      autoLoad={false}
                      fields="name,email,picture"
                      scope="public_profile,email,pages_show_list,read_insights,pages_manage_posts,pages_messaging,pages_manage_metadata,pages_read_engagement,pages_read_user_content,instagram_basic,instagram_manage_comments,instagram_manage_messages,instagram_content_publish,instagram_manage_insights"
                      callback={responseInstagram} // Use a different callback if needed
                      version="20.0"
                      buttonStyle={{
                        padding: "5px 10px",
                        fontSize: "16px",
                        borderRadius: "5px",
                        width: "114px",
                        height: "40px",
                        textTransform: "capitalize",
                        fontFamily: "inter",
                        backgroundColor: "#2990DF",
                        borderOutline: "none",
                        border: "none",
                        fontWeight: "400",
                      }}
                      textButton="Connect"
                    />
                  ) : int.name === "Instagram" &&
                    activeOrganization.InstagramIntegrations[0] ? (
                    <PrimaryButton
                      size="sm"
                      style={{
                        textTransform: "capitalize",
                        width: "114px",
                        height: "40px",
                        backgroundColor: "#E0E3E8",
                        color: "#000",
                      }}
                      color="danger"
                      onClick={() => handleDisconnectRequest(int.name)}
                    >
                      Disconnect
                    </PrimaryButton>
                  ) : int.status === "Not Connected" ? (
                    <PrimaryButton
                      size="sm"
                      color="primary"
                      style={{
                        textTransform: "capitalize",
                        backgroundColor: "#2990DF",
                        width: "93px",
                        height: "40px",
                      }}
                      onClick={() => connectIntegration(int.name)}
                    >
                      Connect
                    </PrimaryButton>
                  ) : (
                    <PrimaryButton
                      style={{
                        textTransform: "capitalize",
                        width: "114px",
                        height: "40px",
                        backgroundColor: "#E0E3E8",
                        color: "#000",
                      }}
                      size="sm"
                      color="danger"
                      onClick={() => handleDisconnectRequest(int.name)}
                    >
                      Disconnect
                    </PrimaryButton>
                  )}
                </CardFooter>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      <Modal
        isOpen={facebookPageSelectionModelOpen}
        toggle={toggleFacebookPageSelectionModal}
        size="md"
      >
        <ModalHeader toggle={toggleFacebookPageSelectionModal}>
          Facebook Page Selection
        </ModalHeader>
        <ModalBody>
          {fbPages && fbPages.length > 0 ? (
            fbPages.map((page, index) => (
              <Row key={index}>
                <Col xl={12}>
                  <Card
                    onClick={() => handlePageSelect(page)}
                    className="p-1 mb-2"
                    style={
                      selectedFbPage && selectedFbPage.id === page.id
                        ? {
                            border: "1px solid #007bff",
                            backgroundColor: "#f0f8ff",
                          }
                        : { border: "1px solid #ddd" }
                    }
                  >
                    <CardBody>
                      <CardTitle tag="p">{page.name}</CardTitle>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            ))
          ) : (
            <p>No pages available</p>
          )}
        </ModalBody>
        <ModalFooter>
          <div>
            <Button size="sm" color="primary" onClick={handlePageSubmit}>
              Connect Page
            </Button>
          </div>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={instagramPageSelectionModelOpen}
        toggle={toggleInstagramPageSelectionModal}
        size="md"
      >
        <ModalHeader toggle={toggleInstagramPageSelectionModal}>
          Instagram Page Selection
        </ModalHeader>
        <ModalBody>
          {instaPages && instaPages.length > 0 ? (
            instaPages.map((page, index) => (
              <Row key={index}>
                <Col xl={12}>
                  <Card
                    onClick={() => handleInstaPageSelect(page)}
                    className="p-1 mb-2"
                    style={
                      selectedInstaPage && selectedInstaPage.id === page.id
                        ? {
                            border: "1px solid #007bff",
                            backgroundColor: "#f0f8ff",
                          }
                        : { border: "1px solid #ddd" }
                    }
                  >
                    <CardBody>
                      <CardTitle tag="p">{page.name}</CardTitle>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            ))
          ) : (
            <p>No pages available</p>
          )}
        </ModalBody>
        <ModalFooter>
          <div>
            <Button size="sm" color="primary" onClick={handleInstaPageSubmit}>
              Connect Page
            </Button>
          </div>
        </ModalFooter>
      </Modal>
      {/* Healthgrade Integerations Modal */}
      <FetchModal
        isOpen={healthgradeConfirmationModelOpen}
        toggle={toggleHealthgradeConfirmationModal}
        mode={mode}
        title="Healthgrade Integration"
        label="Your Healthgrade Profile URL"
        placeholder="Enter Healthgrade profile URL"
        value={healthgradeUrl}
        onChange={handleHealthgradeUrlChange}
        fetchedData={healthgridFetchedData}
        loading={loading}
        onFetch={fetchData}
        onConfirm={confirmHealthgrade}
        confirmText="Confirm"
        fetchText="Fetch"
      />
      {/* <Modal
        isOpen={healthgradeConfirmationModelOpen}
        toggle={toggleHealthgradeConfirmationModal}
        size="md"
      >
        <ModalHeader toggle={toggleHealthgradeConfirmationModal}>
          Healthgrade Integration
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="healthgradeUrl">Your HealthGrade Profile URL</Label>
            <Input
              id="healthgradeUrl"
              type="url"
              placeholder="Enter HealthGrade profile URL"
              value={healthgradeUrl}
              onChange={handleHealthgradeUrlChange}
            />
          </FormGroup>

          {healthgridFetchedData && (
            <Card className="mt-4 p-3 bg-light">
              <CardBody>
                <h4 className="text-primary">
                  {healthgridFetchedData.facility}
                </h4>
                <p className="text-muted mb-1">
                  <strong>Address:</strong> {healthgridFetchedData.address}
                </p>
              </CardBody>
            </Card>
          )}
        </ModalBody>

        <ModalFooter>
          <div className="d-flex gap-3">
            {loading ? (
              <Button color="primary" disabled>
                <Spinner size="sm" className="me-2" />
              </Button>
            ) : (
              <Button color="primary" onClick={fetchData}>
                Fetch
              </Button>
            )}

            {loading ? (
              <Button color="primary" disabled>
                <Spinner size="sm" className="me-2" />
              </Button>
            ) : (
              <Button
                color="success"
                onClick={confirmHealthgrade}
                disabled={!healthgridFetchedData}
              >
                Confirm
              </Button>
            )}
          </div>
        </ModalFooter>
      </Modal> */}
      {/* Vitals Integerations Modal */}
      <FetchModal
        isOpen={vitalsConfirmationModelOpen}
        toggle={toggleVitalsConfirmationModal}
        mode={mode}
        title="Vitals Integration"
        label="Your Vitals Profile URL"
        placeholder="Enter Vitals profile URL"
        value={vitalsUrl}
        onChange={handleVitalsUrlChange}
        fetchedData={vitalsFetchedData}
        loading={loading}
        onFetch={fetchData}
        onConfirm={confirmVitals}
        confirmText="Confirm"
        fetchText="Fetch"
      />
      <Modal
        isOpen={athenaConfirmationModelOpen}
        toggle={toggleAthenaConfirmationModal}
        size="md"
      >
        <ModalHeader toggle={toggleAthenaConfirmationModal}>
          Vitals Integration
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label
              for="athenaId"
              onClick={() => {
                console.log("Athena", athenaId)
              }}
            >
              Your Athena Practice Id
            </Label>
            <Input
              id="athenaId"
              type="text"
              placeholder="Enter Athena Practice ID"
              value={athenaId}
              onChange={e => {
                setAthenaId(e.target.value)
              }}
            />
          </FormGroup>
        </ModalBody>

        <ModalFooter>
          <div className="d-flex gap-3">
            {loading ? (
              <Button color="primary" disabled>
                <Spinner size="sm" className="me-2" />
              </Button>
            ) : (
              <Button
                color="success"
                onClick={onConfirmAthena}
                disabled={!athenaId}
              >
                Confirm
              </Button>
            )}
          </div>
        </ModalFooter>
      </Modal>
      {/* <Modal
        isOpen={yelpConfirmationModelOpen}
        toggle={toggleYelpConfirmationModal}
        size="md"
      >
        <ModalHeader toggle={toggleYelpConfirmationModal}>
          Yelp Integration
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="yelpUrl">Your Yelp Profile URL</Label>
            <Input
              id="yelpUrl"
              type="url"
              placeholder="Enter Yelp profile URL"
              value={yelpUrl}
              onChange={handleYelpUrlChange}
            />
          </FormGroup>

          {yelpFetchedData && (
            <Card className="mt-4 p-3 bg-light">
              <CardBody>
                <h4 className="text-primary">{yelpFetchedData.facility}</h4>
                <p className="text-muted mb-1">
                  <strong>Address:</strong> {yelpFetchedData.address}
                </p>
              </CardBody>
            </Card>
          )}
        </ModalBody>

        <ModalFooter>
          <div className="d-flex gap-3">
            {loading ? (
              <Button color="primary" disabled>
                <Spinner size="sm" className="me-2" />
              </Button>
            ) : (
              <Button color="primary" onClick={fetchData}>
                Fetch
              </Button>
            )}

            {loading ? (
              <Button color="primary" disabled>
                <Spinner size="sm" className="me-2" />
              </Button>
            ) : (
              <Button
                color="success"
                onClick={confirmYelp}
                disabled={!yelpFetchedData}
              >
                Confirm
              </Button>
            )}
          </div>
        </ModalFooter>
      </Modal> */}
      <FetchModal
        isOpen={yelpConfirmationModelOpen}
        toggle={toggleYelpConfirmationModal}
        mode={mode}
        title="Yelp Integration"
        label="Your Yelp Profile URL"
        placeholder="Enter Yelp profile URL"
        value={yelpUrl}
        onChange={handleYelpUrlChange}
        fetchedData={yelpFetchedData}
        loading={loading}
        onFetch={fetchData}
        onConfirm={confirmYelp}
        confirmText="Confirm"
        fetchText="Fetch"
      />
      <Modal
        isOpen={analyticsModalOpen}
        toggle={toggleAnalyticsModal}
        size="lg"
      >
        <ModalHeader toggle={toggleAnalyticsModal}>
          Select Google Analytics Account
        </ModalHeader>
        <ModalBody>
          {viewAccounts.length > 0 ? (
            viewAccounts.map(account => (
              <Card
                key={account.id}
                onClick={() => {
                  console.log("vs", account)
                  setSelectedAccount(account)
                  fetchProperties(account?.name.split("/")[1])
                }}
                className={`p-2 mb-2 ${
                  selectedAccount?.id === account.id
                    ? "bg-light border-primary"
                    : ""
                }`}
              >
                <CardBody>
                  <CardTitle>{account.displayName}</CardTitle>
                </CardBody>
              </Card>
            ))
          ) : (
            <Spinner />
          )}

          {viewProperties.length > 0 && (
            <>
              <h5 className="mt-4">Select Property</h5>
              {viewProperties.map(property => (
                <Card
                  key={property.id}
                  onClick={() => setSelectedProperty(property)}
                  className={`p-2 mb-2 ${
                    selectedProperty?.id === property.id
                      ? "bg-light border-primary"
                      : ""
                  }`}
                >
                  <CardBody>
                    <CardTitle>{property.displayName}</CardTitle>
                  </CardBody>
                </Card>
              ))}
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={confirmGoogleAnalyticsConnection}
            disabled={!selectedProperty}
          >
            Confirm
          </Button>
        </ModalFooter>
      </Modal>
      {/* <Modal
        isOpen={confirmationModalOpen}
        toggle={toggleConfirmationModal}
        size="md"
      >
        <ModalHeader toggle={toggleConfirmationModal}>
          Confirm Disconnection
        </ModalHeader>
        <ModalBody>
          Are you sure you want to disconnect{" "}
          <strong>{integrationToDisconnect}</strong>?
        </ModalBody>
        <ModalFooter>
          <Button
            color="danger"
            onClick={handleConfirmDisconnect}
            disabled={loading}
          >
            {loading ? <Spinner size="sm" /> : "Yes, Disconnect"}
          </Button>
          <Button color="secondary" onClick={toggleConfirmationModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal> */}
      <DeleteConfirmationModal
        isOpen={confirmationModalOpen}
        toggle={() => setConfirmationModalOpen(!confirmationModalOpen)}
        mode={mode}
        title="Confirm Disconnection"
        message={`Are you sure you want to disconnect ${integrationToDisconnect}?`}
        confirmText="Disconnect"
        cancelText="Cancel"
        loading={loading}
        onConfirm={handleConfirmDisconnect}
        onCancel={() => setConfirmationModalOpen(false)}
      />
    </div>
  )
}

export default IntegrationsPage
